import ApplicationName from './ApplicationName.container';

export default ApplicationName;
